import {action, makeAutoObservable} from "mobx";
import CommonStore from "../../../stores/CommonStore";
import ArticleWarehouse from "../../../entities/productOrder/article/ArticleWarehouse";
import { ArticleWarehouseService } from "../../../service/ArticleWarehouseService";

const ERROR_MAP = {
    name: ["ERROR_00_400_33"],
}

class NewArticleWarehouseStore {

    public articleWarehouseId?: string;
    public articleWarehouse: ArticleWarehouse;
    public isEditing: boolean;
    public isModalOpen: boolean;
    public loading: boolean;
    public nameError?: string;
    public commonStore: CommonStore;


    constructor(commonStore: CommonStore, articleWarehouseId?: string) {
        this.isEditing = !!articleWarehouseId;
        this.articleWarehouseId = articleWarehouseId;
        this.isModalOpen = false;
        this.articleWarehouse = {} as ArticleWarehouse;
        this.loading = false;
        this.commonStore = commonStore;
        makeAutoObservable(this);
    }

    get enableButton(): boolean {
        return !!(this.articleWarehouse?.name);
    }

    @action
    public async loadArticleWarehouse() {
        if (this.articleWarehouseId) {
            this.isEditing = true;
            const response = await ArticleWarehouseService.find(this.articleWarehouseId!)
            if (response.success && response.data) {
                this.articleWarehouse = response.data;
            }
            this.commonStore.processErrors(response);
        }
    }

    @action
    public async openModal() {
        this.loading = true;
        await this.loadArticleWarehouse();
        this.isModalOpen = true;
        this.loading = false;
    }

    @action
    public closeModal() {
        this.isModalOpen = false;
    }

    @action
    public async save(): Promise<boolean> {
        this.loading = true;
        const serviceToCall = this.isEditing ? ArticleWarehouseService.update : ArticleWarehouseService.create;
        const response = await serviceToCall(this.articleWarehouse!!);
        this.commonStore.processErrors(response);
        this.processError(response.error);
        this.loading = false;
        return response.success;
    }

    processError(error?: string) {
        this.nameError = undefined;
        if (error) {
            if (ERROR_MAP.name.includes(error)) {
                this.nameError = error;
            }
        }

    }
}

export default NewArticleWarehouseStore;

